function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaveLaterTemplate = require('./save-later.template');
var _require = require('./overlay.shell'),
  applyPublishOverlayShell = _require.applyPublishOverlayShell;
var _require2 = require('../script_build'),
  lockingView = _require2.lockingView;
function escapeHtml(text) {
  return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function formatScriptForDisplay(script) {
  return JSON.stringify(script, null, 2);
}
var SaveLaterFlow = /*#__PURE__*/function () {
  function SaveLaterFlow(app, mod, mainUi) {
    var _this = this;
    _classCallCheck(this, SaveLaterFlow);
    this.app = app;
    this.mod = mod;
    this.mainUi = mainUi;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.overlay["class"] = 'saito-overlay rs-publish-overlay-shell';
    this.overlay.clickBackdropToClose = true;
    this.overlay.nonBlocking = false;
    this.open = false;
    this.onEscapeKey = function (event) {
      if (event.key === 'Escape' && _this.open) {
        _this.hide();
      }
    };
  }
  return _createClass(SaveLaterFlow, [{
    key: "openOverlay",
    value: function openOverlay() {
      var locking = lockingView(this.mod.getScript());
      this.open = true;
      this.show(SaveLaterTemplate.saveOverlay({
        scriptDisplay: escapeHtml(formatScriptForDisplay(locking))
      }));
      this.bindEvents();
    }
  }, {
    key: "show",
    value: function show(html) {
      document.body.classList.add('rs-publish-modal-open');
      this.overlay.show(html);
      applyPublishOverlayShell(this.overlay);
      document.addEventListener('keydown', this.onEscapeKey);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.open = false;
      document.body.classList.remove('rs-publish-modal-open');
      document.removeEventListener('keydown', this.onEscapeKey);
      this.overlay.hide();
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _root$querySelector,
        _this2 = this,
        _root$querySelector2;
      var root = document.querySelector('.rs-save-later');
      if (!root) {
        return;
      }
      (_root$querySelector = root.querySelector('[data-action="save-later-download"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function () {
        try {
          var locking = lockingView(_this2.mod.getScript());
          _this2.mod.exportScriptDraft(locking);
        } catch (_err) {
          /* export failed */
        }
      });
      (_root$querySelector2 = root.querySelector('[data-action="save-later-home"]')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('click', function () {
        var _this2$mainUi;
        _this2.hide();
        (_this2$mainUi = _this2.mainUi) === null || _this2$mainUi === void 0 || (_this2$mainUi = _this2$mainUi.welcomeOverlay) === null || _this2$mainUi === void 0 || _this2$mainUi.render('splash');
      });
    }
  }]);
}();
module.exports = SaveLaterFlow;